export const IN_APP = 'IN_APP';
export const PUBLIC = 'PUBLIC';